// extracted by mini-css-extract-plugin
export default {"inputTitle":"automation-text-template_inputTitle__Z4YiJ"};